export default __webpack_public_path__ + "static/media/set-transaction-pin.153121c2.svg";